// import errorHandlers from '@/services/error-handlers';
import http from '@/services/http';
import errorHandlers from '@/services/error-handlers';


export default {
  namespaced: true,


  state: {
    departments: {},
    employees: {},
    selected: {
      departmentId: null,
      employeeId: null
    }
  },


  getters: {
    selectedDepartment(state) {
      return state.departments[state.selected.departmentId];
    },

    selectedEmployee(state) {
      return state.employees[state.selected.employeeId];
    }
  },


  actions: {
    async fetchDepartment({ commit }, departmentId) {
      try {
        const { data } = await http.get(`/cardfree-api/v1/location/departments/${departmentId}`);
        commit('SET_DEPARTMENT', data);
        commit('SET_SELECTED_DEPARTMENT_ID', data.publicId);
      }
      catch (error) {
        errorHandlers.generic(error);
      }
    },

    async fetchDepartments({ commit }, storeId) {
      try {
        const { data: departments } = await http.get(`/cardfree-api/v1/location/store/${storeId}/departments`);

        const departmentsByPublicId = departments.reduce((obj, department) => {
          obj[department.publicId] = department;
          return obj;
        }, {});

        commit('SET_DEPARTMENTS', departmentsByPublicId);
      }
      catch (error) {
        errorHandlers.generic(error);
      }
    },

    async fetchEmployee({ commit }, employeeId) {
      try {
        const { data } = await http.get(`/cardfree-api/v1/location/employees/${employeeId}`);
        commit('SET_EMPLOYEE', data);
        commit('SET_DEPARTMENT', data.department);

        commit('SET_SELECTED_EMPLOYEE_ID', data.publicId);
        commit('SET_SELECTED_DEPARTMENT_ID', data.department.publicId);
      }
      catch (error) {
        errorHandlers.generic(error);
      }
    },

    async fetchEmployeeGoogleWalletLink({ commit }, { employeeId, params }) {
      try {
        const { data: linkUrl } = await http.get(`/cardfree-api/v1/wallet/employee/${employeeId}/google`, { params });
        commit('SET_EMPLOYEE_GOOGLE_WALLET_LINK', { employeeId, linkUrl });
      }
      catch (error) {
        errorHandlers.generic(error);
      }
    }
  },


  mutations: {
    SET_SELECTED_DEPARTMENT_ID(state, publicId) {
      state.selected.departmentId = publicId;
    },

    SET_SELECTED_EMPLOYEE_ID(state, publicId) {
      state.selected.employeeId = publicId;
    },

    SET_EMPLOYEE(state, employee) {
      state.employees = {
        ...state.employees,
        [employee.publicId]: employee
      };
    },

    SET_EMPLOYEE_GOOGLE_WALLET_LINK(state, { employeeId, linkUrl }) {
      state.employees[employeeId].googleWalletLink = linkUrl;
    },

    SET_DEPARTMENT(state, department) {
      state.departments = {
        ...state.departments,
        [department.publicId]: department
      };
    },

    SET_DEPARTMENTS(state, departments) {
      state.departments = {
        ...state.departments,
        ...departments
      };
    }
  }
};
